import { useLocation } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Tile, BTN_INVERT } from '@/components/bento';

// A Bento tile on the page colour, so a wrong URL looks like the same product
// in either theme. It was a fixed light-slate card, which flashed white in the
// middle of the dark site.
export default function PageNotFound() {
    const location = useLocation();
    const pageName = location.pathname.substring(1);

    return (
        <div className="min-h-screen flex items-center justify-center p-4 sm:p-6 bg-zinc-950">
            <Tile className="max-w-md w-full p-8 sm:p-10 text-center flex flex-col items-center">
                <img src="/images/builderslab-logo.png" alt="BuildersLab" className="h-9 w-auto" />

                {/* 404 Error Code */}
                <p className="mt-8 text-7xl font-extrabold tracking-[-0.05em] leading-none text-orange-500" aria-hidden="true">
                    404
                </p>

                {/* Main Message */}
                <h1 className="mt-5 text-2xl font-extrabold tracking-tight text-white">
                    Page Not Found
                </h1>
                <p className="mt-3 text-zinc-400 leading-relaxed">
                    The page <span className="font-semibold text-zinc-200">"{pageName}"</span> could not be found in this application.
                </p>

                {/* Action Button */}
                <button
                    onClick={() => window.location.href = '/'}
                    className={`mt-8 inline-flex items-center gap-2 h-11 px-6 rounded-full text-sm font-bold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 ${BTN_INVERT}`}
                >
                    <Home className="w-4 h-4" aria-hidden="true" />
                    Go Home
                </button>
            </Tile>
        </div>
    )
}
